import { CommonModule } from '@angular/common';
import { inject } from "@angular/core";
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiLogoComponent } from '@common/ui/frontend-shared/logo/logo';
import { AppState } from '@core/frontend-shared/app-state';
import { Store } from '@ngxs/store';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
import * as i2 from "@angular/common";
function CoreChunkErrorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
    i0.ɵɵelement(3, "ui-logo", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ui-content-centered")(5, "div")(6, "h1", 4);
    i0.ɵɵelement(7, "ui-icon", 5);
    i0.ɵɵtext(8, " Fehler ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10, " Ein Teil der App konnte nicht geladen werden. Dies kann passieren, wenn eine neue Version ver\u00F6ffentlicht wurde, aber Ihr Ger\u00E4t gleichzeitig noch eine alte Version nutzt. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p");
    i0.ɵɵtext(12, " Bitte laden Sie die Seite neu, um den Fehler zu beheben. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p")(14, "button", 6);
    i0.ɵɵlistener("click", function CoreChunkErrorComponent_Conditional_0_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clickReload());
    });
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("scaling", 100);
  }
}
/**
 * error component used by access guard
 */
export let CoreChunkErrorComponent = /*#__PURE__*/(() => {
  class CoreChunkErrorComponent {
    constructor() {
      this.chunkError$ = inject(Store).select(AppState.chunkError);
    }
    clickReload() {
      window.location.reload();
    }
    static {
      this.ɵfac = function CoreChunkErrorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreChunkErrorComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreChunkErrorComponent,
        selectors: [["core-chunk-error"]],
        decls: 2,
        vars: 3,
        consts: [[1, "overlay"], [1, "infobox"], [1, "logowrapper"], ["background", "true", "id", "logo", 3, "scaling"], [1, "ui-margin-remove"], ["icon", "exclamation-triangle"], ["uiButton", "", "label", "Seite neu laden", "icon", "sync-alt", 1, "ui-button-contrast", 3, "click"]],
        template: function CoreChunkErrorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CoreChunkErrorComponent_Conditional_0_Template, 15, 1, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.chunkError$) ? 0 : -1);
          }
        },
        dependencies: [CommonModule, UiContentCenteredComponent, UiButtonComponent, UiIconsModule, i1.UiIconComponent, UiLogoComponent, i2.AsyncPipe],
        styles: [".overlay[_ngcontent-%COMP%]{position:fixed;inset:0;z-index:9998;background:var(--invertedOverlaySoftColor);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);transition:background-color .3s}.overlay[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.infobox[_ngcontent-%COMP%]{background:var(--contentColor);color:var(--textColor);padding:20px 120px 20px 20px;width:600px;max-width:90%;position:relative}.infotext[_ngcontent-%COMP%]{margin:30px 0}.logowrapper[_ngcontent-%COMP%]{position:absolute;width:100px;right:0;top:0}"],
        changeDetection: 0
      });
    }
  }
  return CoreChunkErrorComponent;
})();